export const MAX_TIMEOUT_MILLISECONDS = 2147483647;
